<template>
    <div id="app">
        <router-view name="top_head" @change_project="change_pro"></router-view>
        <router-view name="left" ></router-view>

        <router-view name="content" v-if="isRouterAlive"></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true
        };
    },
    methods: {
        change_pro() {
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            })
        },
    },
}
</script>

<style>
/*@import "../src/assets/css/simplebar.css";*/
@import "../src/assets/css/bootstrap.min.css";
/*@import "../src/assets/css/animate.css";*/
/*@import "../src/assets/css/icons.css";*/
/*@import "../src/assets/css/sidebar-menu.css";*/
@import "../src/assets/css/app-style.css";
@import "../src/assets/css/style.css";
/*@import "../src/assets/css/new_login.css";*/
/*!*ibms系统的css*!*/
@import "./assets/login/style.css";
/*@import "./assets/themes/minified/agileui/color-schemes/layouts/default.min.css";*/
/*@import "./assets/themes/minified/agileui/color-schemes/elements/default.min.css";*/
</style>
